import { type SupportedCountryCode } from '@zep-us/i18n';

/**
 * GNB에서 지원하는 국가 코드
 * - KR, JP: SupportedCountryCode에서 픽
 * - ETC: 그 외 모든 국가
 */
export type GnbCountryCode = Extract<SupportedCountryCode, 'KR' | 'JP'> | 'ETC';

const DOCS_BASE_URL = 'https://docs.channel.io/zepquiz';
/**
 * 모든 국가를 지원하는 고객지원 링크
 */
const GLOBAL_SUPPORT_LINKS = {
  notice: {
    KR: `${DOCS_BASE_URL}/ko/categories/86331fb5-공지사항`,
    JP: `${DOCS_BASE_URL}/ja/categories/86331fb5-공지사항`,
    ETC: `${DOCS_BASE_URL}/en/categories/86331fb5-공지사항`,
  },
  updateNews: {
    KR: `${DOCS_BASE_URL}/ko/categories/업데이트-소식-4c851069`,
    JP: `${DOCS_BASE_URL}/ja/categories/업데이트-소식-4c851069`,
    ETC: `${DOCS_BASE_URL}/en/categories/업데이트-소식-4c851069`,
  },
  guide: {
    KR: `${DOCS_BASE_URL}/ko`,
    JP: `${DOCS_BASE_URL}/ja`,
    ETC: `${DOCS_BASE_URL}/en`,
  },
  faq: {
    // 진짜 한국도 일본어가 한국주소임. 링크 처음에 잘못만듯
    KR: `${DOCS_BASE_URL}/ko/categories/よくあるご質問-da3f7890`,
    JP: `${DOCS_BASE_URL}/ja/categories/よくあるご質問-da3f7890`,
    ETC: `${DOCS_BASE_URL}/en/categories/よくあるご質問-da3f7890`,
  },
  event: {
    KR: `${DOCS_BASE_URL}/ko/categories/이벤트-소식-c60ca637`,
    JP: '',
    ETC: '',
  },
} as const satisfies Record<string, Record<GnbCountryCode, string>>;

export type SupportLinkType = keyof typeof GLOBAL_SUPPORT_LINKS;

const toGnbCountryCode = (code: string): GnbCountryCode =>
  code === 'KR' || code === 'JP' ? code : 'ETC';

type SupportLinks = {
  [K in SupportLinkType]: string;
};

/**
 * 국가 코드에 맞는 모든 고객지원 링크를 객체로 반환
 * - KR, JP는 해당 국가 링크 반환
 * - 그 외 국가는 ETC 링크 반환
 */
export const getSupportLinks = (countryCode: string): SupportLinks => {
  const gnbCountryCode = toGnbCountryCode(countryCode);
  return {
    notice: GLOBAL_SUPPORT_LINKS.notice[gnbCountryCode],
    updateNews: GLOBAL_SUPPORT_LINKS.updateNews[gnbCountryCode],
    guide: GLOBAL_SUPPORT_LINKS.guide[gnbCountryCode],
    faq: GLOBAL_SUPPORT_LINKS.faq[gnbCountryCode],
    event: GLOBAL_SUPPORT_LINKS.event[gnbCountryCode],
  };
};
